import {mainServer} from '../../../../../variables/config'

export const request_approval_contact = async (approval_id) => {
  const logData = JSON.parse(localStorage.getItem('data'))
  mainServer.instance.defaults.headers.common['Authorization'] = logData.token
  let response = await mainServer.instance.get(`/approvalcontact/${approval_id}`)
  return response.data.data.approval_contact
}

